import axios from 'axios';
import AnalyticsPublic from '../../base/AnalyticsPublic';
import cookie from 'js-cookie';

export default {
  name: 'FilterService',

  queryDict(filter, callback) {
    let reqKey = null;
    let params = {
      platformid: AnalyticsPublic.platform.toString(),
      productid: AnalyticsPublic.productid,
    };
    const token = cookie.get('_app_token_');

    if (filter === 'partner') {
      reqKey = `/app/rest/partner.json/getByProduct/${token}`;
    } else if (filter === 'version') {
      reqKey = `/app/rest/version.json/getByProduct/${token}`;
    } else if (filter === 'usergroup') {
      params = {};
      reqKey = `/cohort/api/v1/cohort/getFinish/USER/${AnalyticsPublic.productid}/${token}`
    }

    return axios.get(reqKey, { params }).then(res => {
      if (res.status === 200) {
        const data = res.data.result ? res.data.result : res.data;
        let tmpMap = {};
        data.forEach(item => {
          if (filter === 'partner') {
            tmpMap[item.partnerid] = item.displayname ? item.displayname : item.partnername;
          } else if (filter === 'version') {
            tmpMap[item.versioncode] = item.versionname;
          } else if (filter === 'usergroup') {
            tmpMap[item.cohortId] = item.cohortName;
          }
        });
        callback(tmpMap)
      }
    });
  }
}
